<template>
  <div
    class="recordInfoContent"
    v-if="
      recordInfo.componentCategory == 1 || recordInfo.componentCategory == 2
    "
  >
    <el-collapse v-model="activeNames">
      <el-collapse-item name="engine" v-if="recordInfo.componentCategory == 1">
        <template #title>
          <span>
            <img src="../../assets/svg/engineIcon.svg" alt="" />
            发动机保养记录
          </span>
        </template>
        <el-table
          ref="tableRef"
          stripe
          border
          highlight-current-row
          :data="engineRecordList"
        >
          <el-table-column
            label="序号"
            type="index"
            width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="保养时间"
            width="140px"
            align="center"
            prop="time"
          ></el-table-column>
          <el-table-column
            label="保养里程"
            width="140px"
            align="center"
            prop="mileage"
          ></el-table-column>
          <el-table-column
            label="保养内容"
            min-width="140px"
            prop="content"
          ></el-table-column>
          <el-table-column label="附件" min-width="140px" prop="photos">
            <template #default="{ row }">
              <file-upload-list
                ref="fileUploadList"
                :fileList="row.photos"
              ></file-upload-list>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item
        name="transmission"
        v-if="recordInfo.componentCategory == 2"
      >
        <template #title>
          <span>
            <img src="../../assets/svg/transmissionIcon.svg" alt="" />
            变速器保养记录
          </span>
        </template>
        <el-table
          ref="tableRef"
          stripe
          border
          highlight-current-row
          :data="transmissionRecordList"
        >
          <el-table-column
            label="序号"
            type="index"
            width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="保养时间"
            width="140px"
            align="center"
            prop="time"
          ></el-table-column>
          <el-table-column
            label="保养里程"
            width="140px"
            align="center"
            prop="mileage"
          ></el-table-column>
          <el-table-column
            label="保养内容"
            min-width="140px"
            prop="content"
          ></el-table-column>
          <el-table-column label="附件" min-width="140px" prop="photos">
            <template #default="{ row }">
              <file-upload-list
                ref="fileUploadList"
                :fileList="row.photos"
              ></file-upload-list>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "recordInfo",
  data() {
    return {
      status: 1,
      activeNames: ["engine", "transmission"], // 全部展开
      engineRecordList: [],
      transmissionRecordList: [],
    };
  },
  props: {
    recordInfo: {
      type: [Array, Object],
      // default:() => []
    },
  },
  async created() {
    this.getrecordInfo();
  },
  methods: {
    getFileInfo(fileItem) {
      const value = fileItem;
      if (Array.isArray(value)) return value;
      if (typeof value === "string") {
        try {
          return JSON.parse(value) || [];
        } catch {
          return [];
        }
      }
      // 其他情况（undefined/null）→ 返回空数组
      return [];
    },
    getrecordInfo() {
      if (this.recordInfo) {
        this.engineRecordList = this.getFileInfo(
          this.recordInfo.maintenanceRecordInfo.engineRecordList
        );
        this.transmissionRecordList = this.getFileInfo(
          this.recordInfo.maintenanceRecordInfo.transmissionRecordList
        );
      }
    },
  },
};
</script>
